// Views/Header.jsx
import { use, useEffect } from "react";
import { auth } from "../firebase";
import { onAuthStateChanged, signOut } from "firebase/auth";
import Logo from '../assets/images/Logo.webp';
import toast from "react-hot-toast";
//import './Header.css'; // optional if you want per-component CSS


// TODO check main.js

export default function HeaderClient({ setCurrentClientView }) {
    var burgerIsOpen = false;
    const wait = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
    const navbarCollapse = document.querySelector('#navbarNine');
    const burgerButton = document.querySelector('.navbar-toggler');
    useEffect(() => {
        const header = document.querySelector(".navbar-area");
        const backToTop = document.querySelector(".scroll-top");

        const handleScroll = () => {
            if (!header) return;
            const sticky = header.offsetTop;

            // Sticky navbar 
            if (window.pageYOffset > sticky) {
                header.classList.add("sticky");
            } else {
                header.classList.remove("sticky");
            }

            // Show or hide the back-to-top button
            if (backToTop) {
                if (document.body.scrollTop > 50 || document.documentElement.scrollTop > 50) {
                    backToTop.style.display = "flex";
                } else {
                    backToTop.style.display = "none";
                }
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => { window.removeEventListener('scroll', handleScroll); };
    }, []);


    useEffect(() => {
        const handleClickOutside = e => {
            const navbarCollapse = document.querySelector('#navbarNine');
            const burgerButton = document.querySelector('.navbar-toggler');
            if (
                navbarCollapse.classList.contains("show") && // navbar is open
                !navbarCollapse.contains(e.target) &&        // click not inside menu
                !burgerButton.contains(e.target)       // and not on the toggler
            ) {
                burgerButton.click(); // close the menu
            }
        };

        document.addEventListener("click", handleClickOutside);
        return () => document.removeEventListener("click", handleClickOutside);
    }, []);




    function toggleNavbar() {
        // Toggle the 'show' class manually
        // TODO FIX ME
        // This has something to do with the way INSTRUCTIONS is handled, it should be obsured by React state rather than removed from the document completely.
        //console.log("Toggling navbar");
        if (navbarCollapse.classList.contains('show')) {
            navbarCollapse.classList.remove('show');
            burgerIsOpen = false;
        } else {
            navbarCollapse.classList.add('show');
            burgerIsOpen = true;
        }
    }

    return (
        <section className="navbar-area navbar-nine">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <nav className="navbar navbar-expand-lg">
                            <a className="navbar-brand" href="#about" onClick={async (e) => {
                                e.preventDefault();
                                setCurrentClientView("home");
                                await wait(100);
                                const target = document.querySelector("#about");
                                if (target) target.scrollIntoView({ behavior: "smooth" }); // scroll to section
                            }}
                            >
                                <img className="toprightlogo" src={Logo} alt="Logo" />
                            </a>
                            <button onClick={toggleNavbar}
                                className="navbar-toggler"
                                type="button"
                                aria-controls="navbarNine"
                                aria-expanded="false"
                                aria-label="Toggle navigation"
                            >
                                <span className="toggler-icon"></span>
                                <span className="toggler-icon"></span>
                                <span className="toggler-icon"></span>
                            </button>

                            <div className="collapse navbar-collapse sub-menu-bar" id="navbarNine">
                                <ul className="navbar-nav me-auto">
                                    <li className="nav-item">
                                        <a className="page-scroll active" href="#aboutcontainer" onClick={async (e) => {
                                            e.preventDefault();
                                            setCurrentClientView("home");
                                            await wait(100);
                                            const target = document.querySelector("#aboutcontainer");
                                            if (target) target.scrollIntoView({ behavior: "smooth" }); // scroll to section
                                        }}
                                        >
                                            Qui sommes nous?
                                        </a>
                                    </li>
                                    <li className="nav-item">
                                        <a className="page-scroll" href="#services" onClick={async (e) => {
                                            e.preventDefault();
                                            setCurrentClientView("home");
                                            await wait(100);
                                            const target = document.querySelector("#services");
                                            if (target) target.scrollIntoView({ behavior: "smooth" }); // scroll to section
                                        }}
                                        >
                                            Nos services
                                        </a>
                                    </li>
                                    <li className="nav-item">
                                        <a className="page-scroll" href="#contact" onClick={async (e) => {
                                            e.preventDefault();
                                            setCurrentClientView("home");
                                            await wait(100);
                                            const target = document.querySelector("#contact");
                                            if (target) target.scrollIntoView({ behavior: "smooth" }); // scroll to section
                                        }}
                                        >
                                            Contact
                                        </a>
                                    </li>
                                    <li className="nav-item">
                                        <a className="page-scroll" href="#instructions-content"
                                            onClick={(e) => {
                                                e.preventDefault();
                                                setCurrentClientView("instruction");
                                            }}
                                        >
                                            Dépôts de documents
                                        </a>
                                    </li>
                                    <li className="nav-item">
                                        <a className="page-scroll" href="#espace-client"
                                            onClick={async (e) => {
                                                try {
                                                    await signOut(auth);
                                                    toast.success("Vous êtes maintenant déconnecté");
                                                } catch (error) {
                                                    toast.error("Logout failed: " + error.message);
                                                }
                                            }}
                                        >
                                            Se Déconnecter
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </nav>
                        {/* navbar */}
                    </div>
                </div>
                {/* row */}
            </div >
            {/* container */}
        </section >
    );
}

